import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2c7b234c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "number-incrementer__label-wrapper"
}
const _hoisted_2 = { class: "number-incrementer__label" }
const _hoisted_3 = { class: "number-incrementer__sub-label" }
const _hoisted_4 = { class: "number-incrementer__button-section" }

import { computed } from 'vue'
import BaseButton from './BaseButton.vue'
import { PropType } from 'vue'
import { SIZES, FORMATS } from '@/enums/components'
import { useI18n } from 'vue-i18n'


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseNumberIncrementer',
  props: {
  label: {
    type: String,
    default: undefined,
  },
  subLabel: {
    type: String,
    default: undefined,
  },
  amount: {
    type: Number,
    default: 0,
  },
  minAmount: {
    type: Number,
    default: undefined,
  },
  maxAmount: {
    type: Number as PropType<number | null | undefined>,
    default: undefined,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  errors: {
    type: Array as PropType<string[]>,
    default: () => [],
  },
},
  emits: [
  'update:modelValue',
  'update:amount',
  'clickMinus',
  'clickPlus',
  'show-warning-message',
],
  setup(__props, { emit: emits }) {

const props = __props



const { t } = useI18n()

const minusTooltip = computed(() =>
  props.minAmount !== undefined
    ? `${t('minQuantity')}: ${props.minAmount}`
    : 'Decrease the number',
)

const plusTooltip = computed(() =>
  props.maxAmount !== undefined
    ? `${t('maxQuantity')}: ${props.maxAmount}`
    : 'Increase the number',
)

const onUpdate = (value: number) => {
  if (props.disabled) return

  const isMinAmountSet = (props.minAmount ?? false) !== false
  if (isMinAmountSet && value < (props.minAmount as number)) return

  const isMaxAmountSet = (props.maxAmount ?? false) !== false
  if (isMaxAmountSet && value > (props.maxAmount as number)) return

  emits('update:modelValue', value)
  emits('update:amount', value)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: _normalizeClass(["number-incrementer", {
        'number-incrementer--disabled': __props.disabled,
        'number-incrementer--error': __props.errors.length,
      }])
    }, [
      (__props.label)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("label", _hoisted_2, _toDisplayString(__props.label), 1),
            _createElementVNode("span", _hoisted_3, _toDisplayString(__props.subLabel), 1)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(BaseButton, {
          icon: "minus",
          "min-amount": __props.minAmount,
          tooltip: _unref(minusTooltip),
          format: _unref(FORMATS).SECONDARY,
          size: _unref(SIZES).SMALL,
          disabled: 
            __props.amount <= 0 || __props.disabled || !!(__props.minAmount && __props.amount <= __props.minAmount)
          ,
          class: "number-incrementer__button",
          type: "button",
          "show-tooltip": true,
          onOnClick: _cache[0] || (_cache[0] = 
            (event) => {
              _ctx.$emit('clickMinus', event)
              onUpdate(__props.amount - 1)
            }
          )
        }, null, 8, ["min-amount", "tooltip", "format", "size", "disabled"]),
        _createElementVNode("div", {
          class: _normalizeClass(["number-incrementer__content", { 'number-incrementer__content--error': __props.errors.length }])
        }, [
          _renderSlot(_ctx.$slots, "default", {}, () => [
            _createTextVNode(_toDisplayString(__props.amount), 1)
          ])
        ], 2),
        _createVNode(BaseButton, {
          "show-tooltip": true,
          "max-amount": __props.maxAmount,
          tooltip: _unref(plusTooltip),
          icon: "plus",
          format: _unref(FORMATS).SECONDARY,
          size: _unref(SIZES).SMALL,
          disabled: 
            __props.disabled ||
            !!((__props.maxAmount || __props.maxAmount === 0) && __props.amount >= __props.maxAmount)
          ,
          class: "number-incrementer__button",
          type: "button",
          onOnClick: _cache[1] || (_cache[1] = 
            (event) => {
              _ctx.$emit('clickPlus', event)
              onUpdate(__props.amount + 1)
            }
          )
        }, null, 8, ["max-amount", "tooltip", "format", "size", "disabled"])
      ])
    ], 2),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.errors, (error) => {
      return (_openBlock(), _createElementBlock("div", {
        key: error,
        class: "error"
      }, _toDisplayString(error), 1))
    }), 128))
  ]))
}
}

})